// ajax模块
export default {
  'err404.tips': "The news you're looking for doesn't exist. Please check other topics. We are waiting for you there!",
};
